<template>
  <v-row align="center">
    <v-col cols="12" sm="3">
      <v-text-field
        dense
        filled
        hide-details
        class="no-before"
        :value="name"
        label="Recherche"
        @change="v => $emit('update:name', v)"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="4">
      <RecipeProductTagsEditor
        dense
        filled
        no-before
        hide-details
        :solo="false"
        label="Mots clés"
        icon=""
        :value="tags"
        @input="v => $emit('update:tags', v)"
      ></RecipeProductTagsEditor>
    </v-col>
    <v-col cols="12" sm="3">
      <v-select
        dense
        filled
        class="no-before"
        hide-details
        label="Catégorie de mots clés"
        :items="getTagCategories"
        item-text="name"
        item-value="id"
        :value="category"
        @change="v => $emit('update:category', v)"
      ></v-select>
    </v-col>
    <v-col cols="12" sm="2">
      <v-row no-gutters justify="end">
        <v-btn height="52px" large depressed @click="$emit('filter')" block
          ><v-icon small left>fa-filter</v-icon> Filtrer</v-btn
        >
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import RecipeProductTagsEditor from "./RecipeProductTagsEditor";
export default {
  name: "ProductBulkEditorFilter",
  components: {
    RecipeProductTagsEditor
  },
  props: {
    name: {
      required: true,
      validator: prop => typeof prop === "string" || prop === null
    },
    tags: {
      type: Array,
      required: true
    },
    category: {
      required: true
    }
  },
  computed: {
    ...mapGetters(["getTagCategories"])
  }
};
</script>

<style></style>
